module.exports = __webpack_public_path__ + "static/media/helvetia_logo_es.dc538ccf.svg";